import { ResponseDTO } from "../../interfaces/response"
import HttpService from "../function/http"

export class HomeServices {
    public _http = new HttpService()

    public async getDashboardOUTByBusiness(idBusiness: number): Promise<ResponseDTO> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/withdrawals/dashboard/${idBusiness}`
        )
        return response
    }

    public async getDashboardINByBusiness(idBusiness: number): Promise<ResponseDTO> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/dashboard/${idBusiness}`
        )
        return response
    }

    public async getTransactionOUTByBusiness(idBusiness: number, period: string, pages: number, take: number): Promise<ResponseDTO> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/withdrawals/businessList/${idBusiness}?order=DESC&page=${pages}&take=${take}&filters=${period}`
        )
        return response
    }

    public async getTransactionINByBusiness(idBusiness: number, period: string, pages: number, take: number): Promise<ResponseDTO> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/invoices/${idBusiness}?order=DESC&page=${pages}&take=${take}&filters=${period}`
        )
        return response
    }

    public async getTransactionRetriveCmsById(idTXTrsnaction: string): Promise<ResponseDTO | any> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/retrive-cms/${idTXTrsnaction}`
        )
        return response
    }
}